import { render, staticRenderFns } from "./CommunicationTestLaptop.vue?vue&type=template&id=b3bea69a&scoped=true&"
import script from "./CommunicationTestLaptop.vue?vue&type=script&lang=js&"
export * from "./CommunicationTestLaptop.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationTestLaptop.vue?vue&type=style&index=0&id=b3bea69a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bea69a",
  null
  
)

export default component.exports